import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError, } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindHistoricoDto } from '@/api.types.extra';
import { HistoricoDto } from '@/api.types';

export async function GetHistoricoTabela(tabela: string, idregistro: number | string) {
  return api
    .get(Endpoints.HISTORICO, {
      params: {
        tabela: tabela,
        registro: idregistro,
        data_inicial: '2000-01-01',
        data_final: '3000-01-01',
      },
    })
    .then((response) => {
      return GetApiReturn<HistoricoDto>(response.data as Array<HistoricoDto>);
    })
    .catch((error) => {
      ValidateAxiosError<HistoricoDto>(error, 'Falha ao buscar histórico.');
      return GetApiReturnError<HistoricoDto>();
    });
}

export async function GetHistoricoUsuario(filters: FindHistoricoDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[HistoricoDto[], number]>(Endpoints.HISTORICO, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar históricos.');
  }
}

/**
   * Mapeamento de chaves para índices.
   */
export const campoMap: Record<string, number> = {
  cpf: 0,
  email: 1,
  data_nascimento: 2,
  data_admissao: 3,
  data_exoneracao: 4,
  data_referencia: 5,
  nome: 6,
  titulo: 7,
  ativo: 8,
  anotacao: 9,
  estadocivil: 10,
  telefone_id: 11,
  celular_id: 12,
  data_entrada: 13,
  data_saida: 14,
  predio_id: 15,
  comarca_id: 16,
  substituta1_id: 17,
  substituta2_id: 18,
  ordem: 19,
  vara_id: 20,
  setor_id: 21,
  id: 22,
  criadoem: 23,
  criadopor: 24,
  editadoem: 25,
  editadopor: 26,
  endereco_id: 27,
  maximo_estagiarios: 28,
  maximo_integrantes: 29,
  agrupar: 30,
  prefixo: 31,
  defensoria_id: 32,
  telefones_id: 33,
  atuacao: 34,
  cnpj: 35,
  razao_social: 36,
  representante_nome: 37,
  representante_cargo: 38,
  bairro: 39,
  cep: 40,
  cidade: 41,
  complemento: 42,
  logradouro: 43,
  numero: 44,
  ddd: 45,
  sigla: 46,
  capacidade: 47,
  status: 48,
  horario_entrada: 49,
  horario_saida: 50
};

/**
 * Transforma um objeto `diff` de chaves string para um mapeamento numérico.
 * @param diff Objeto com as diferenças registradas.
 * @returns Objeto com chaves numéricas.
 */
export function TratarDiferenca(diff: Record<string, any>): Record<number, any> {
  const diffMap: Record<number, any> = {};

  if (diff) {
    try {
      delete diff.editadoem;

      /**
       * Mapeia os campos automaticamente.
       */
      for (const [campo, valor] of Object.entries(diff)) {
        const indice = campoMap[campo];
        if (indice !== undefined) diffMap[indice] = valor;
      }

      /**
       * Se não houver alterações, define um valor nulo.
       */
      if (Object.keys(diffMap).length === 0) diffMap[100] = null; // Histórico vazio
    } catch (error) {
      console.error('Erro ao processar diff:', error);
    }
  }

  return diffMap;
}
